import { type ActivityCategory, getActivityConfigByCategory } from "@storytell/streaming";
import {
  TbAddressBook,
  TbBooks,
  TbBrain,
  TbBrandGithub,
  TbBrandGmail,
  TbBrandGoogleDrive,
  TbBrandNotion,
  TbBrandSlack,
  TbBulb,
  TbCalendar,
  TbChartBar,
  TbCheck,
  TbClipboardList,
  TbDatabase,
  TbFileText,
  TbGlobe,
  TbHourglass,
  TbMessage,
  TbMessageCircle,
  TbMessageQuestion,
  TbPhoto,
  TbPlug,
  TbPresentation,
  TbRobot,
  TbRoute,
  TbSparkles,
  TbUser,
  TbVideo,
  TbWand,
  TbWaveSquare,
} from "solid-icons/tb";
import type { JSX } from "solid-js";
import { LinearIcon } from "./linear/linearIcon";

const CheckIcon = (props: { class?: string }) => <TbCheck class={props.class ?? "size-3.5"} />;

export const ICON_COMPONENTS: Record<string, (props: { class?: string }) => JSX.Element> = {
  globe: (props) => <TbGlobe class={props.class ?? "size-3.5"} />,
  brain: (props) => <TbBrain class={props.class ?? "size-3.5"} />,
  chart: (props) => <TbChartBar class={props.class ?? "size-3.5"} />,
  route: (props) => <TbRoute class={props.class ?? "size-3.5"} />,
  books: (props) => <TbBooks class={props.class ?? "size-3.5"} />,
  robot: (props) => <TbRobot class={props.class ?? "size-3.5"} />,
  "file-text": (props) => <TbFileText class={props.class ?? "size-3.5"} />,
  "message-question": (props) => <TbMessageQuestion class={props.class ?? "size-3.5"} />,
  "message-circle": (props) => <TbMessageCircle class={props.class ?? "size-3.5"} />,
  "address-book": (props) => <TbAddressBook class={props.class ?? "size-3.5"} />,
  check: CheckIcon,
  sparkles: (props) => <TbSparkles class={props.class ?? "size-3.5"} />,
  wand: (props) => <TbWand class={props.class ?? "size-3.5"} />,
  "clipboard-list": (props) => <TbClipboardList class={props.class ?? "size-3.5"} />,
  bulb: (props) => <TbBulb class={props.class ?? "size-3.5"} />,
  database: (props) => <TbDatabase class={props.class ?? "size-3.5"} />,
  hourglass: (props) => <TbHourglass class={props.class ?? "size-3.5"} />,
  photo: (props) => <TbPhoto class={props.class ?? "size-3.5"} />,
  video: (props) => <TbVideo class={props.class ?? "size-3.5"} />,
  presentation: (props) => <TbPresentation class={props.class ?? "size-3.5"} />,
  "brand-google-drive": (props) => <TbBrandGoogleDrive class={props.class ?? "size-3.5"} />,
  "brand-notion": (props) => <TbBrandNotion class={props.class ?? "size-3.5"} />,
  "brand-slack": (props) => <TbBrandSlack class={props.class ?? "size-3.5"} />,
  "brand-gmail": (props) => <TbBrandGmail class={props.class ?? "size-3.5"} />,
  "brand-linear": (props) => <LinearIcon class={props.class ?? "size-3.5"} />,
  "brand-github": (props) => <TbBrandGithub class={props.class ?? "size-3.5"} />,
  calendar: (props) => <TbCalendar class={props.class ?? "size-3.5"} />,
  plug: (props) => <TbPlug class={props.class ?? "size-3.5"} />,
  message: (props) => <TbMessage class={props.class ?? "size-3.5"} />,
  "wave-square": (props) => <TbWaveSquare class={props.class ?? "size-3.5"} />,
  user: (props) => <TbUser class={props.class ?? "size-3.5"} />,
};

export function getCategoryIcon(category: ActivityCategory, iconClass?: string): JSX.Element {
  const config = getActivityConfigByCategory(category);
  const iconKey = config?.iconKey ?? "check";
  const iconFn = ICON_COMPONENTS[iconKey] ?? CheckIcon;
  return iconFn({ class: iconClass });
}

export function getCategoryBgColor(category: ActivityCategory): string {
  const config = getActivityConfigByCategory(category);
  return config?.colorClass ?? "bg-gray-600 dark:bg-gray-500";
}

export const getScopeBadgeClasses = (scope: string): string => {
  switch (scope.toLowerCase()) {
    case "system":
      return "bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-400";
    case "project":
      return "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400";
    case "user":
      return "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400";
    default:
      return "bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400";
  }
};
